import React from 'react';
import Table from 'components/base/Table';
import styled from 'styled-components';
import {
  Flex,
  TableNoVerticalLinesAndNoFirstAndLastBorder
} from 'components/base/layout-components';
import { RADIUS, SPACES } from 'common/constants/sizes';

const TableWrapper = styled(Flex)`
  width: 100%;
  border-radius: ${RADIUS.large};
  margin-bottom: ${SPACES.small};
`;

const TableWrapperNoLines = styled(TableNoVerticalLinesAndNoFirstAndLastBorder)`
  width: 100%;
  margin-bottom: ${SPACES.small};
`;

const getTableConfig = isRBACEnabled =>
  [
    isRBACEnabled && {
      name: '',
      dataPoint: 'bulkSelection',
      tableCellProps: {
        style: { width: '1%', paddingRight: '1rem', paddingLeft: '1rem' }
      }
    },
    { name: 'NAME', dataPoint: 'name' },
    { name: 'ROLE', dataPoint: 'role' },
    isRBACEnabled && {
      name: '',
      dataPoint: 'warning',
      tableCellProps: {
        style: { width: '1%', paddingRight: '1px', paddingLeft: '2.3rem' }
      }
    },
    isRBACEnabled && {
      name: 'TEAMS',
      dataPoint: 'teams',
      tableCellProps: {
        style: { paddingLeft: '0.5rem', width: '20%' }
      }
    },
    { name: 'EMAIL', dataPoint: 'email' },
    { name: 'SOURCE', dataPoint: 'source' },
    { name: 'INVITATION DATE', dataPoint: 'invitation_date' },
    { name: 'ACTIVATION DATE', dataPoint: 'activation_date' },
    isRBACEnabled
      ? { name: '', dataPoint: 'actions', showOnlyOnHover: true }
      : { name: 'ACTIONS', dataPoint: 'actions' }
  ].filter(Boolean);

const UsersTable = React.memo(({ data, isRBACEnabled }) => {
  const Wrapper = isRBACEnabled ? TableWrapperNoLines : TableWrapper;
  return (
    <Wrapper>
      <Table
        columns={getTableConfig(isRBACEnabled)}
        data={data}
        withPagination={isRBACEnabled}
        clientSidePagination={isRBACEnabled}
      />
    </Wrapper>
  );
});

export default UsersTable;
